import React from "react"
import {AsyncResultRequestState} from "../../types/asyncResult"
import {OkDocument, ErrorDocument} from "../../resources/common"
import {ManagedSolutionsAccount} from "../../resources/managedSolutions"
import {IcomoonIconName} from "../Icon/icons"
import {NavLink} from "../NavLink/NavLink"
import Icon from "../Icon/Icon"

interface OrgAccountsSidebarItemProps {
	label: string
	icon: IcomoonIconName
	operationalAccounts: AsyncResultRequestState<OkDocument<ManagedSolutionsAccount[]>, ErrorDocument>
}

export function OrgAccountsSidebarItem({label, icon, operationalAccounts}: OrgAccountsSidebarItemProps) {
	const link = operationalAccounts.match(
		() => null,
		(result) => {
			const accounts = result.data
			if (accounts.length === 0) {
				return null
			} else if (accounts.length === 1) {
				return `/managed-solutions/accounts/${accounts[0].id}`
			} else {
				return "/managed-solutions/org-accounts"
			}
		},
		() => null
	)

	if (!link) {
		return null
	}

	return (
		<li>
			<NavLink className="has-icon" activeClassName="is-active" to={link}>
				<div className="border-effect"></div>
				<span className="icon">
					<Icon size={16} icon={icon} />
				</span>
				<span className="nav-link-label">{label}</span>
			</NavLink>
		</li>
	)
}
